import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotRecommendations from './components/HotRecommendations';
import CategoryNav from './components/CategoryNav';
import LatestUpdates from './components/LatestUpdates';
import RankingSection from './components/RankingSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '韩漫漫画网站',
  url: 'https://www.example.com/',
  description: '韩漫漫画网站作为海量正版漫画的在线阅读平台，提供免费的韩国漫画大全，确保您的每次阅读都建立在正规资源之上。',
  inLanguage: 'zh-Hans',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.example.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '韩漫漫画网站',
  url: 'https://www.example.com/',
  description: '海量正版韩国漫画在线阅读平台',
  foundingDate: '2022',
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }} />

      <Navbar />

      <main>
        <HeroSection />
        <HotRecommendations />
        <CategoryNav />
        <LatestUpdates />
        <RankingSection />
        <TestimonialSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}